import React from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";

const HeaderS2 = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <header id="header" className="header-s2">
            <div className={"" + props.hclass}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <MobileMenu />
                            </div>
                            <div className="col-lg-2 col-md-6 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home">
                                        <img src={props.Logo} alt="logo" />
                                        <span className="logo-text">PCIC</span>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li>
                                            <Link onClick={ClickHandler} className="active" to="/">Home</Link>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={(e) => e.preventDefault()} to="#">Services <i className="ti-angle-down"></i></Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/service-single/Daily-Prayers">Daily Prayers</Link></li>
                                                <li><Link onClick={ClickHandler} to="/service-single/Islamic-Education">Islamic Education</Link></li>
                                                <li><Link onClick={ClickHandler} to="/service-single/Community-Support">Community Support</Link></li>
                                                <li><Link onClick={ClickHandler} to="/service-single/Youth-Programmes">Youth Programmes</Link></li>
                                                <li><Link onClick={ClickHandler} to="/service-single/Community-Events">Community Events</Link></li>
                                            </ul>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={(e) => e.preventDefault()} to="#">Events <i className="ti-angle-down"></i></Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/event-single/Jumuah-Prayer">Jumu'ah Prayer</Link></li>
                                                <li><Link onClick={ClickHandler} to="/event-single/Quran-Classes">Quran Classes</Link></li>
                                                <li><Link onClick={ClickHandler} to="/event-single/Community-Iftar">Community Iftar</Link></li>
                                                <li><Link onClick={ClickHandler} to="/event-single/Eid-Celebration">Eid Celebration</Link></li>
                                                <li><Link onClick={ClickHandler} to="/event-single/Youth-Programme">Youth Programme</Link></li>
                                                <li><Link onClick={ClickHandler} to="/event-single/Sisters-Circle">Sisters Circle</Link></li>
                                            </ul>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/about">About Us</Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/wall-of-akhirah">Wall of Akhirah</Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/contact">Contact Us</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-2 col-2">
                                <div className="header-right">
                                    <div className="close-form">
                                        <Link onClick={ClickHandler} className="theme-btn" to="/donate">Donate now</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}
const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
    };
};


export default connect(mapStateToProps, { removeFromCart })(HeaderS2);